import React from 'react'
import { Step4 } from 'steps/Step4'

export const StepList = ({
  brk,
  isEmbed,
  userType,
  getIsLocked,
  getIsComplete,
  getIsScrollComplete,
  unlockNextStep,
  onGoToNext,
  onStepStart,
  onStepComplete,
  onStepSkip,
  onAuthRequired,
  onAwardPoints,
  onAttemptStepStart,
  onIntersect,
  handleInstantWinEvent,
}) => {
  const hasTopNav = brk?.navigationType === 'TOP'

  return brk.steps.map((step, i) => {
    const position = brk.hasLandingScreen ? i + 1 : i

    return (
      <div
        key={i}
        className={`step-3-template${hasTopNav ? ' top-navigation' : ''} sponsored-flow-wrapper step-${step.id} step-position-${position}`}
        data-position={position}
        data-stepid={step.id}
        data-steptype={step.type}
      >
        <div
          className={`step-scroll-position-${position}`}
          style={{ position: 'relative' }}
        />
        <div
          className={`step-topper step-topper-${i + 1} step-topper-${step.id}`}
          style={{
            position: 'absolute',
            marginTop: 'var(--content-desktop-offset-top)',
          }}
          id={`step-${i + 1}`}
        />
        <Step4
          key={i}
          brk={brk}
          step={step}
          breakId={brk.id}
          stepId={step.id}
          isComplete={getIsComplete(step.id)}
          isLocked={!isEmbed && getIsLocked(step.id)}
          onGoToNext={onGoToNext}
          onStepStart={onStepStart}
          onStepComplete={onStepComplete}
          unlockNextStep={unlockNextStep}
          onStepSkip={onStepSkip}
          isEmbed={isEmbed}
          scrollComplete={getIsScrollComplete(step.id)}
          onAuthRequired={onAuthRequired}
          onAwardPoints={onAwardPoints}
          onAttemptStepStart={onAttemptStepStart}
          startScreenDisabled={step.startScreenDisabled || false}
          handleInstantWinEvent={handleInstantWinEvent}
          userType={userType}
          onIntersect={onIntersect}
        />
      </div>
    )
  })
}
